import {
  SET_VAULT_ACT_SEARCH_CRITERIA,
  CLEAR_VAULT_ACT_SEARCH_CRITERIA,
} from '../actions/actionTypes';

import { pageSize } from '../../pages/VaultingActivity/constants';

const initialState = {
  limit: pageSize,
  offset: 0,
  sort: '-createdOn',
};

const vaultActSearchCriteriaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VAULT_ACT_SEARCH_CRITERIA:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_VAULT_ACT_SEARCH_CRITERIA:
      return initialState;
    default:
      return state;
  }
};

export default vaultActSearchCriteriaReducer;
